import React from "react";

function BlankLayout({ children }) {

	return <div className="blank-page h-100 dark">{children}</div>;
}

export default BlankLayout;
